import React from "react";
import "./Tooltip.css";
const Tooltip = ({ text, position, tooltipRef }) => {
  if (!text) return null; // Тултип не рендерится, если text отсутствует

  return (
    <div
      ref={tooltipRef}
      className="tooltip"
      style={{ top: position.top, left: position.left }}
    >
      {text}
      <div className="arrow"></div>
    </div>
  );
};

export default Tooltip;
